import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { TitleService } from '../../services';
import { Breadcrumbs } from '../../store';
import { TypeAhead } from '@spoiler-alert/ui-library';
import Tabs from '../../components/tabs/tabs';
import SellerSites from './seller-sites';
import BuyerSites from './buyer-sites';
import { SiteNameTypeAheadQuery } from '../../graphql/queries';

const Sites = ({ history }) => {
  useEffect(() => {
    TitleService.setTitles('Sites Administration');
    Breadcrumbs.set([
      {
        url: '/sites',
        title: 'Sites Administration',
      },
    ]);
  }, []);

  const handleSearchType = (value) => {
    if (!value?.result) return;
    if (value.result.siteType === 'FACILITY') {
      history.push(`/sites/${value.result.rootSite}/${value.result._id}`);
    } else {
      history.push(`/sites/${value.result._id}/${value.result._id}`);
    }
  };

  return (
    <div>
      <TypeAhead query={SiteNameTypeAheadQuery} queryName="siteNameTypeAheadQuery" onChange={handleSearchType} />
      <Tabs
        panes={[
          {
            path: '',
            label: 'Sellers',
            Component: SellerSites,
          },
          {
            path: 'buyers',
            label: 'Buyers',
            Component: BuyerSites,
          },
        ]}
        history={history}
      />
    </div>
  );
};

Sites.propTypes = {
  history: PropTypes.object,
};

export default Sites;
